import { createContext } from 'react'

export const HeadContext = createContext({
	data: {},
	renderedData: [],
});

export default HeadContext;